// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".43a29d9adb0090ba62d7eeffa71979f0.js";
};